import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useCallback } from "react";
import api, { RetailerDto } from "../../../api";
import { PaginatedDataGrid, PaginationData } from "../../controls";

export interface RetailersGridProps {
  onRowSelected: (row: RetailerDto | null) => void;
}

export const RetailersGrid = (props: RetailersGridProps) => {
  const { onRowSelected } = props;

  const loadData = useCallback(async (page: number, size: number, sort: string, filter: string): Promise<PaginationData<RetailerDto>> => {
    return await api.retailer.find({ page, size, sort, name: filter } as any);
  }, []);

  const columns: GridColDef<RetailerDto>[] = [
    { field: "name", headerName: "Name", minWidth: 200, flex: 400, editable: false, sortable: true, filterable: false },
    { field: "templateFileType", headerName: "Template", width: 100 , editable: false, sortable: true, filterable: false, align: "center", headerAlign: "center" },
    { field: "isEnabled", headerName: "Enabled", width: 80, editable: false, sortable: true, filterable: false, align: "center", headerAlign: "center", valueFormatter: (p) => (p.value ? "Yes" : "No") },
    { field: "createdAt", headerName: "Created", width: 150, editable: false, sortable: true, filterable: false, valueFormatter: (p) => dayjs(p.value).format("YYYY-MM-DD HH:mm:ss") },
  ];

  return <PaginatedDataGrid name="Retailers" loadData={loadData} columns={columns} onRowSelected={onRowSelected} showFilter />;
};
